import { UtilityService } from './index'

class SampleServices {

    async getSampleQr() {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getSampleRequestQR', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async listSamples(page, _id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/SampleRequests', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                page: page,
                styleReferenceId: _id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getSampleRequestListById(_id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getSampleRequestOneById', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: _id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async prefillSRDetails() {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getSR', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return result.json();
    }

    async createSampleRequest(data) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/saveBasicDetails', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }
    async saveMeasurementChar(data,data1,id) {
        let result = await fetch(UtilityService.baseUrl() + `api/sampleRequest/${id}/editMeasurementChat` ,{
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({measurementChat:data,shrinkagePercentage:data1})
        });
        return {
            status: result.status,
            text: await result.json()
        }
    }
    async duplicateMeasurementChat(data,id){
        let result = await fetch(UtilityService.baseUrl() + `api/sampleRequest/${id}/duplicateMeasurementChat` ,{
            method:"PUT",
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({targetSampleRequestId:data})
        });
        return{
            status: result.status,
            text: await result.json()
        }
    }

    async addMoreTypeOfSize(data){
        let result = await fetch(UtilityService.baseUrl() + `api/sampleRequest/addMoreTypeOfSizes`,{
            method:"POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        }
    }

    async measurementChatDetails(id){
        let result = await fetch(UtilityService.baseUrl() + `api/sampleRequest/${id}/measurementChat`, {
            method:"GET",
            headers:{
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            }
        });
        return {
            status: result.status,
            text: await result.json()
        }
    }

    async downloadExcel(id,value) {
        try {
            let result = await fetch(UtilityService.baseUrl() + `api/sampleRequest/export/${id}/${value}`, {
                method: "GET",
                headers: {
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // Excel MIME type
                    'AuthToken': localStorage.getItem("authToken")
                }
            });
    
            if (!result.ok) {
                throw new Error(`Error: ${result.status}`);
            }
    
            const blob = await result.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
    
            link.href = url;
            link.setAttribute("download", `SampleRequest_${id}.xlsx`); // File name
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
    
        } catch (error) {
            console.error("Download failed:", error);
        }
    }

    async editSampleRequest(data, styleInfo) {

        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/saveBasicDetails', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                "_id": data._id,
                "originationOfRequest": data.originationOfRequest,
                "magnumStyleId": styleInfo.value,
                "styleReferenceId": styleInfo.referenceId,
                "typeOfRequest": data.typeOfRequest,
                "sampleType": data.sampleType,
                "requiredDate": data.requiredDate,
                "buyerName": data.buyerName,
                "assistantBuyer": data.assistantBuyer,
                "fabricTechnologist": data.fabricTechnologist,
                "garmentTechnology": data.garmentTechnology,
                "technologist": data.technologist,
                "customer": styleInfo.customerId,
                "customerDepartmentId": styleInfo.customerDepartmentId
            })
        });
        return result.json();
    }

    async removeSample(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/deleteSampleRequest', {
            method: "DELETE",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return {
            text: await result.json(),
            status: result.status,
        };
    }
    async createSample(data) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/sampleDetails', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createPattern(value) {

        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/pattern', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(value)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async completePattern(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/patternComplete', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createGarment(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/garmentTechnology', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(value)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async completeGarment(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/garmentTechnologyComplete', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }
    async createFabric(data) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/fabric', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async completeFabric(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/fabricComplete', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async createTrim(data) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/trim', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async completeTrim(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/trimComplete', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async createEmbelishment(data) {

        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/embellishment', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        }
            ;
    }

    async completeEmbelishment(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/embellishmentCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createCutting(info) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/cutting', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(info)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createQC(info) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/qc', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(info)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async completeQC(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/qcCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async completeCutting(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/cuttingComplete', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createSignOff(data) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/signOff', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(data)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async completeSignOff(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/signOffCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createSewing(info) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/sewing', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(info)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async completeSewing(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/sewingCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async createDispatch(info) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/dispatch', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(info)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async completeDispatch(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/dispatchCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }
    async cloneMeeting(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/meetingNotes/cloneMN', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id
            })
        });
        return result.json();
    }


    async SampleInfo(id,SRNo) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getSampleRequest', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: id,
                requestNumber: SRNo,
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }



async getTrimPdf(id,styleInfo) {
  try {
    const result = await fetch(
      UtilityService.baseUrl() + "api/sampleRequest/getTrimCardData",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken"),
        },
        body: JSON.stringify({
          _id: id,
          downloadPdf: true,
        }),
      }
    );

    // check api response
    if (!result.ok) {
      throw new Error("Failed to download PDF");
    }

    // convert response to blob
    const blob = await result.blob();

    // create download url
    const url = window.URL.createObjectURL(blob);

    // create temp anchor tag
    const link = document.createElement("a");
    link.href = url;

    // file name
    link.setAttribute("download", `trim_card_${styleInfo}.pdf`);

    // append and click
    document.body.appendChild(link);
    link.click();

    // cleanup
    link.remove();
    window.URL.revokeObjectURL(url);

    return {
      status: result.status,
    };
  } catch (error) {
    console.error("getTrimPdf Error:", error);

    return {
      status: 500,
      error: error.message,
    };
  }
}

    async getSampleReqNo(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/costing/searchSR', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: value !== '' ? JSON.stringify({
                requestNumber: value
            }) : ''
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getStyleInfo(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/costing/getSRData', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                requestId: value
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getFabricNo(reqId, value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/costing/getFabricData', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                requestId: value,
                fabricNumber: reqId
            })
        });
        return result.json();

    }

    async getAllFabrics(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/costing/getFabric', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({

                fabricNumber: value
            })
        });
        return result.json();

    }
    async getFabricName(requestId, fabricNo) {

        let result = await fetch(UtilityService.baseUrl() + 'api/costing/getFabricSR', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                requestId: requestId.value,
                fabricId: fabricNo.value
            })
        });
        return result.json();

    }


    async getSupplierInfo(fabricNo) {
        let result = await fetch(UtilityService.baseUrl() + 'api/costing/getFabricSupplier', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                fabricId: fabricNo.value
            })
        });
        return result.json();

    }

    async getSupplierInfoForTrim(trimNo) {
        let result = await fetch(UtilityService.baseUrl() + 'api/costing/getTrimSupplier', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                trimId: trimNo.value
            })
        });
        return result.json();

    }

    async getTrimNo(reqId, value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/costing/getTrimData', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                requestId: value,
                trimNumber: reqId
            })
        });
        return result.json();

    }

    async getAllTrims(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/costing/getTrim', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                trimNumber: value

            })
        });
        return result.json();

    }

    async getTrimName(requestId, fabricNo) {


        let result = await fetch(UtilityService.baseUrl() + 'api/costing/getTrimSR', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                requestId: requestId.value,
                trimId: fabricNo.value
            })
        });
        return result.json();

    }


    async searchSamplesBy(searchStylesBy, searchFor) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/search', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                "for": searchFor,
                "by": searchStylesBy

            })
        });
        return {
            status: result.status,
            text: await result.json()
        };

    }


    async getDoneBy(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getEmployees', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                text: value

            })
        });
        return result.json();

    }


    async createCAD(info) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/addCAD', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(info)
        });
        return {
            status: result.status,
            text: await result.json()
        };

    }

    async completeCAD(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/cadCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };

    }

    async createCosting(info) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/costing', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(info)
        });
        return {
            status: result.status,
            text: await result.json()
        };

    }

    async completeCosting(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/costingCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };

    }


    async createEmbroidery(info) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/embroidery', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(info)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async completeEmbroidery(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/embroideryCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async createWash(info) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/wash', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(info)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async completeWash(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/washCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments

            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async createMarker(info) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/addMarker', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(info)
        });
        return {
            status: result.status,
            text: await result.json()
        };

    }
    async completeMarker(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/markerCompleted', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments

            })
        });
        return {
            status: result.status,
            text: await result.json()
        };

    }


    async completeSample(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/sampleDetailsComplete', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                _id: value._id,
                comments: value.comments
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }


    async getCustomerData(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getSampleRequestCustomerData', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                "customerId": value.customer,
                "departmentId": value.customerDepartmentId,
                "type": value.type
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };

    }

    async getCustomerData2(value) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getSampleRequestCustandDepartData', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                "customerId": value.customer,
                "departmentId": value.customerDepartmentId,
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    //get fabric info for sampleRequest 
    async getFabricInfo(_id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getFabric', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                fabricId: _id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    //get trim info for sampleRequest 
    async getTrimInfo(_id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getTrim', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                trimId: _id
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async getTrimNumber(trimCategory, trimNumberSearch) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/getTrims', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({
                trimCategory: trimCategory,
                trimNumber: trimNumberSearch
            })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async auditForSample(id, moduleName) {
        let moduleVal = moduleName === "garmenttechnologist" ? "garmentTechnologist" : moduleName;
        let result = await fetch(UtilityService.baseUrl() + `api/modulesLogs/getSampleLog/${moduleVal}/${id}`, {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async ProcessUpdates(info) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/updateSRProcessAll', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(info)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async sampleTagByStyle(ids) {
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/sampleTagByStyle', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({ 'ids': ids })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }
    async bulkUpdateDispatch(obj) {        
        let result = await fetch(UtilityService.baseUrl() + 'api/sampleRequest/bulkUpdateDispatch', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(obj)
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

}
export default new SampleServices();


// WEBPACK FOOTER //
// ./src/services/sample.service.js